export default __webpack_public_path__ + "static/media/avatar_122.0ea187db.png";